
/* =======================================================
   1. REUSABLE SIZE CHART COMPONENT INITIALIZER
======================================================= */
function initSizeChartComponent(container) {
  if (!container) return;

  const mainTabs = container.querySelectorAll(".size-main-tabs li");
  const panels = container.querySelectorAll(".size-main-content");

  // Main Tabs Switching
  mainTabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      mainTabs.forEach(t => t.classList.remove("active"));
      panels.forEach(p => p.classList.remove("active"));

      tab.classList.add("active");

      const targetPanel = container.querySelector(`.size-main-content#${tab.dataset.tab}`);
      if (targetPanel) {
        targetPanel.classList.add("active");

        // Trigger first sub-tab radio if present
        const firstRadio = targetPanel.querySelector(".size-tabs input[type='radio']");
        if (firstRadio) {
          firstRadio.checked = true;
          firstRadio.dispatchEvent(new Event("change"));
        }
      }
    });
  });

  // Sub-Tabs (Radio) Switching
  panels.forEach(function (panel) {
    const radios = panel.querySelectorAll(".size-tabs input[type='radio']");
    const contents = panel.querySelectorAll(".tab-content");

    radios.forEach(function (radio, index) {
      radio.addEventListener("change", function () {
        if (radio.checked) {
          radios.forEach(function (r) {
            const label = panel.querySelector(`label[for="${r.id}"]`);
            if (label) label.classList.remove("active");
          });

          const activeLabel = panel.querySelector(`label[for="${radio.id}"]`);
          if (activeLabel) activeLabel.classList.add("active");

          contents.forEach(c => c.classList.remove("active"));
          if (contents[index]) contents[index].classList.add("active");
        }
      });
    });

    // Set initial sub-tab content state
    if (radios.length > 0) {
      const checkedRadio = Array.from(radios).find(r => r.checked) || radios[0];
      const checkedIndex = Array.from(radios).indexOf(checkedRadio);

      const label = panel.querySelector(`label[for="${checkedRadio.id}"]`);
      if (label) label.classList.add("active");

      contents.forEach(c => c.classList.remove("active"));
      if (contents[checkedIndex]) contents[checkedIndex].classList.add("active");
    } else {
      const firstContent = panel.querySelector(".tab-content");
      if (firstContent) firstContent.classList.add("active");
    }
  });
}

/* =======================================================
   2. GLOBAL POPUP HANDLER (FOR PRODUCT PAGES / AJAX)
======================================================= */
window.openSizeChart = function (category) {
  const popup = document.getElementById("SizeChartPopup");
  if (!popup) return;

  popup.classList.add("active");
  document.body.style.overflow = "hidden";

  const val = (category || popup.dataset.sizeCategory || "").toLowerCase().trim();
  let mainTabKey = "women";
  let subTabKey = "chuck";

  if (val.includes("women")) mainTabKey = "women";
  else if (val.includes("men")) mainTabKey = "men";
  else if (val.includes("kid")) mainTabKey = "kids";
  else if (val.includes("gender free") || val.includes("apparel")) mainTabKey = "apparel";

  if (val.includes("chuck")) subTabKey = "chuck";
  else if (val.includes("standard")) subTabKey = "standard";
  else if (val.includes("top")) subTabKey = "top";
  else if (val.includes("bottom")) subTabKey = "bottom";

  const tabs = popup.querySelectorAll(".size-main-tabs li");
  const panels = popup.querySelectorAll(".size-main-content");

  tabs.forEach(t => t.classList.remove("active"));
  panels.forEach(p => p.classList.remove("active"));

  const targetTab = popup.querySelector(`.size-main-tabs li[data-tab="${mainTabKey}"]`) || tabs[0];
  const targetPanel = popup.querySelector(`.size-main-content#${mainTabKey}`) || panels[0];

  if (targetTab) targetTab.classList.add("active");
  if (!targetPanel) return;

  targetPanel.classList.add("active");

  const radios = targetPanel.querySelectorAll(".size-tabs input[type='radio']");
  const contents = targetPanel.querySelectorAll(".tab-content");

  if (radios.length > 0) {
    const targetRadio = targetPanel.querySelector(`input[id*="${subTabKey}"]`) || radios[0];
    radios.forEach(r => (r.checked = false));
    targetRadio.checked = true;

    targetPanel.querySelectorAll("label").forEach(l => l.classList.remove("active"));
    const targetLabel = targetPanel.querySelector(`label[for="${targetRadio.id}"]`);
    if (targetLabel) targetLabel.classList.add("active");

    const radioIndex = Array.from(radios).indexOf(targetRadio);
    contents.forEach(c => c.classList.remove("active"));
    if (contents[radioIndex]) contents[radioIndex].classList.add("active");
  } else {
    contents.forEach(c => c.classList.remove("active"));
    if (contents[0]) contents[0].classList.add("active");
  }
};

/* =======================================================
   3. DOM READY LISTENERS
======================================================= */
document.addEventListener("DOMContentLoaded", function () {
  // Initialize all size chart sections on the page (popup and static page)
  document.querySelectorAll("#SizeChart, #SizeChartPopup, .size-chart").forEach(function (chart) {
    initSizeChartComponent(chart);
  });

  // Popup Modal Controls
  const popup = document.getElementById("SizeChartPopup");
  if (popup) {
    function closePopup() {
      popup.classList.remove("active");
      document.body.style.overflow = "";
    }

    popup.querySelector(".size-chart-close")?.addEventListener("click", function (e) {
      e.stopPropagation();
      closePopup();
    });

    popup.querySelector(".size-chart-overlay")?.addEventListener("click", closePopup);

    popup.querySelector(".size-chart-modal")?.addEventListener("click", function (e) {
      e.stopPropagation();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && popup.classList.contains("active")) {
        closePopup();
      }
    });
  }

  // Crosshair Table Hover Effect
  document.querySelectorAll(".sizeGuideSizeChart").forEach(function (table) {
    const rows = Array.from(table.querySelectorAll("tr"));

    rows.forEach(function (row, rowIndex) {
      row.querySelectorAll("th, td").forEach(function (cell, columnIndex) {
        cell.addEventListener("mouseenter", function () {
          table.querySelectorAll(".hover-row").forEach(el => el.classList.remove("hover-row"));
          table.querySelectorAll(".hover-column").forEach(el => el.classList.remove("hover-column"));

          row.classList.add("hover-row");

          for (let i = 0; i <= rowIndex; i++) {
            const current = rows[i].children[columnIndex];
            if (current) current.classList.add("hover-column");
          }
        });
      });
    });

    table.addEventListener("mouseleave", function () {
      table.querySelectorAll(".hover-row").forEach(el => el.classList.remove("hover-row"));
      table.querySelectorAll(".hover-column").forEach(el => el.classList.remove("hover-column"));
    });
  });
});




(function () {

  let originalParent = null;
  let originalNextSibling = null;

  function isQuickViewSizeGuide(button) {
    return !!button.closest('#quick-add-dialog dialog');
  }

  function openSizeChartAboveQuickView() {

    const sizeChart = document.getElementById('SizeChartPopup');

    if (!sizeChart) {
      console.warn('SizeChartPopup not found');
      return;
    }

    /* Save original location */
    if (!originalParent) {
      originalParent = sizeChart.parentNode;
      originalNextSibling = sizeChart.nextSibling;
    }

    /* ---------------------------------------
       Create native dialog
       --------------------------------------- */

    let sizeChartDialog =
      document.getElementById('SizeChartQuickViewDialog');

    if (!sizeChartDialog) {

      sizeChartDialog = document.createElement('dialog');

      sizeChartDialog.id =
        'SizeChartQuickViewDialog';

      document.body.appendChild(sizeChartDialog);

    }

    /* ---------------------------------------
       Move existing Size Chart inside dialog
       --------------------------------------- */

    sizeChartDialog.appendChild(sizeChart);

    /* Existing popup open state */
    sizeChart.classList.add('active');

    sizeChart.style.display = 'flex';

    /* ---------------------------------------
       Open native dialog
       --------------------------------------- */

    if (!sizeChartDialog.open) {
      sizeChartDialog.showModal();
    }

  }


  function closeQuickViewSizeChart() {

    const sizeChart =
      document.getElementById('SizeChartPopup');

    const sizeChartDialog =
      document.getElementById('SizeChartQuickViewDialog');

    if (!sizeChart) return;


    /* Close native dialog */

    if (sizeChartDialog && sizeChartDialog.open) {
      sizeChartDialog.close();
    }


    /* Remove quick-view specific state */

    sizeChart.classList.remove(
      'active'
    );


    sizeChart.style.display = '';


    /* ---------------------------------------
       Put Size Chart back where it was
       --------------------------------------- */

    if (originalParent) {

      if (
        originalNextSibling &&
        originalNextSibling.parentNode === originalParent
      ) {

        originalParent.insertBefore(
          sizeChart,
          originalNextSibling
        );

      } else {

        originalParent.appendChild(
          sizeChart
        );

      }

    }

  }


  /* ==========================================
     QUICK VIEW SIZE GUIDE CLICK
     ========================================== */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '.size-chart-trigger'
        );

      if (!button) return;


      /* Only intercept Quick View */

      if (!isQuickViewSizeGuide(button)) {
        return;
      }


      /*
       * IMPORTANT:
       *
       * Existing inline:
       *
       * onclick="openSizeChart('')"
       *
       * ko prevent karna hai.
       */

      event.preventDefault();
      event.stopImmediatePropagation();


      /*
       * Open existing Size Chart
       * ABOVE Quick View
       */

      openSizeChartAboveQuickView();

    },
    true
  );


  /* ==========================================
     SIZE CHART CLOSE BUTTON
     ========================================== */

  document.addEventListener(
    'click',
    function (event) {

      const closeButton =
        event.target.closest(
          '.size-chart-close'
        );

      if (!closeButton) return;


      const dialog =
        document.getElementById(
          'SizeChartQuickViewDialog'
        );

      /*
       * Only handle it if Size Chart
       * is currently inside our dialog.
       */

      if (
        !dialog ||
        !dialog.contains(closeButton)
      ) {
        return;
      }


      event.preventDefault();
      event.stopImmediatePropagation();

      closeQuickViewSizeChart();

    },
    true
  );


  /* ==========================================
     ESC KEY
     ========================================== */

  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key !== 'Escape') return;

      const dialog =
        document.getElementById(
          'SizeChartQuickViewDialog'
        );

      if (!dialog || !dialog.open) return;

      closeQuickViewSizeChart();

    },
    true
  );


})();
// /* ======================================
//    Global Function: Open & Auto-Select Tab
// ====================================== */
// window.openSizeChart = function (category) {
//   const popup = document.getElementById("SizeChartPopup");
//   if (!popup) return;

//   // 1. Open Popup
//   popup.classList.add("active");
//   document.body.style.overflow = "hidden";

//   // 2. Determine Main and Sub Tab Keys
//   const val = (category || popup.dataset.sizeCategory || "").toLowerCase().trim();
//   let mainTabKey = "women"; // Fallback main tab
//   let subTabKey = "chuck";  // Fallback sub tab

//   if (val.includes("women")) {
//     mainTabKey = "women";
//   } else if (val.includes("men")) {
//     mainTabKey = "men";
//   } else if (val.includes("kid")) {
//     mainTabKey = "kids";
//   } else if (val.includes("gender free") || val.includes("apparel")) {
//     mainTabKey = "apparel";
//   }

//   if (val.includes("chuck")) {
//     subTabKey = "chuck";
//   } else if (val.includes("standard")) {
//     subTabKey = "standard";
//   } else if (val.includes("top")) {
//     subTabKey = "top";
//   } else if (val.includes("bottom")) {
//     subTabKey = "bottom";
//   }

//   // 3. Switch Main Tab & Panel
//   const tabs = popup.querySelectorAll(".size-main-tabs li");
//   const panels = popup.querySelectorAll(".size-main-content");

//   tabs.forEach(t => t.classList.remove("active"));
//   panels.forEach(p => p.classList.remove("active"));

//   const targetTab = popup.querySelector(`.size-main-tabs li[data-tab="${mainTabKey}"]`) || tabs[0];
//   const targetPanel = document.getElementById(mainTabKey) || panels[0];

//   if (targetTab) targetTab.classList.add("active");
//   if (!targetPanel) return;

//   targetPanel.classList.add("active");

//   // 4. Switch Sub-Tab inside Active Panel
//   const radios = targetPanel.querySelectorAll(".size-tabs input[type='radio']");
//   const contents = targetPanel.querySelectorAll(".tab-content");

//   if (radios.length > 0) {
//     const targetRadio = targetPanel.querySelector(`input[id*="${subTabKey}"]`) || radios[0];
    
//     radios.forEach(r => (r.checked = false));
//     targetRadio.checked = true;

//     targetPanel.querySelectorAll("label").forEach(l => l.classList.remove("active"));
//     const targetLabel = targetPanel.querySelector(`label[for="${targetRadio.id}"]`);
//     if (targetLabel) targetLabel.classList.add("active");

//     const radioIndex = Array.from(radios).indexOf(targetRadio);
//     contents.forEach(c => c.classList.remove("active"));
//     if (contents[radioIndex]) contents[radioIndex].classList.add("active");
//   } else {
//     // For panels without radio buttons (Kids Shoes)
//     contents.forEach(c => c.classList.remove("active"));
//     if (contents[0]) contents[0].classList.add("active");
//   }
// };

// /* ======================================
//    Global Event Delegations & Listeners
// ====================================== */
// document.addEventListener("DOMContentLoaded", function () {
//   const popup = document.getElementById("SizeChartPopup");

//   function closePopup() {
//     if (popup) {
//       popup.classList.remove("active");
//       document.body.style.overflow = "";
//     }
//   }

//   // Close Button, Overlay & Modal stopPropagation
//   popup?.querySelector(".size-chart-close")?.addEventListener("click", function (e) {
//     e.stopPropagation();
//     closePopup();
//   });

//   popup?.querySelector(".size-chart-overlay")?.addEventListener("click", closePopup);

//   popup?.querySelector(".size-chart-modal")?.addEventListener("click", function (e) {
//     e.stopPropagation();
//   });

//   document.addEventListener("keydown", function (e) {
//     if (e.key === "Escape" && popup?.classList.contains("active")) {
//       closePopup();
//     }
//   });

//   // Manual Main Tab Switching
//   popup?.querySelectorAll(".size-main-tabs li").forEach(function (tab) {
//     tab.addEventListener("click", function () {
//       const tabs = popup.querySelectorAll(".size-main-tabs li");
//       const panels = popup.querySelectorAll(".size-main-content");

//       tabs.forEach(t => t.classList.remove("active"));
//       panels.forEach(p => p.classList.remove("active"));

//       tab.classList.add("active");

//       const target = document.getElementById(tab.dataset.tab);
//       if (target) {
//         target.classList.add("active");
//         const firstRadio = target.querySelector(".size-tabs input[type='radio']");
//         if (firstRadio) {
//           firstRadio.checked = true;
//           firstRadio.dispatchEvent(new Event("change"));
//         }
//       }
//     });
//   });

//   // Manual Sub-Tab (Radio) Switching
//   popup?.querySelectorAll(".size-main-content").forEach(function (panel) {
//     const radios = panel.querySelectorAll(".size-tabs input[type='radio']");
//     const contents = panel.querySelectorAll(".tab-content");

//     radios.forEach(function (radio, index) {
//       radio.addEventListener("change", function () {
//         if (radio.checked) {
//           radios.forEach(function (r) {
//             const label = panel.querySelector(`label[for="${r.id}"]`);
//             if (label) label.classList.remove("active");
//           });

//           const activeLabel = panel.querySelector(`label[for="${radio.id}"]`);
//           if (activeLabel) activeLabel.classList.add("active");

//           contents.forEach(c => c.classList.remove("active"));
//           if (contents[index]) contents[index].classList.add("active");
//         }
//       });
//     });
//   });

//   // Table Crosshair Hover Effect
//   document.querySelectorAll(".sizeGuideSizeChart").forEach(function (table) {
//     const rows = Array.from(table.querySelectorAll("tr"));

//     rows.forEach(function (row, rowIndex) {
//       row.querySelectorAll("th, td").forEach(function (cell, columnIndex) {
//         cell.addEventListener("mouseenter", function () {
//           table.querySelectorAll(".hover-row").forEach(el => el.classList.remove("hover-row"));
//           table.querySelectorAll(".hover-column").forEach(el => el.classList.remove("hover-column"));

//           row.classList.add("hover-row");

//           for (let i = 0; i <= rowIndex; i++) {
//             const current = rows[i].children[columnIndex];
//             if (current) current.classList.add("hover-column");
//           }
//         });
//       });
//     });

//     table.addEventListener("mouseleave", function () {
//       table.querySelectorAll(".hover-row").forEach(el => el.classList.remove("hover-row"));
//       table.querySelectorAll(".hover-column").forEach(el => el.classList.remove("hover-column"));
//     });
//   });
// });